"use client"

import { format } from "date-fns"
import { ptBR } from "date-fns/locale"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"

export interface NffHistoryItem {
    id: number
    batch: string
    nff: string
    created_at: string
    generated_by: string | null
}

interface NffHistoryModalProps {
    nffHistory: NffHistoryItem[]
}

export function NffHistoryModal({ nffHistory }: NffHistoryModalProps) {
    if (!nffHistory || nffHistory.length === 0) {
        return (
            <div className="flex items-center justify-center py-12">
                <div className="text-center">
                    <div className="text-sm text-muted-foreground mb-1">Nenhum histórico encontrado</div>
                    <div className="text-xs text-muted-foreground">Esta nota fiscal não possui histórico de NFF</div>
                </div>
            </div>
        )
    }

    return (
        <div className="space-y-4">
            <div className="text-sm font-medium">
                {nffHistory.length} {nffHistory.length === 1 ? "registro encontrado" : "registros encontrados"}
            </div>

            <div className="rounded-lg border bg-card">
                <div className="overflow-x-auto">
                    <Table>
                        <TableHeader>
                            <TableRow className="hover:bg-transparent">
                                <TableHead className="font-semibold text-xs uppercase tracking-wide">NFF</TableHead>
                                <TableHead className="font-semibold text-xs uppercase tracking-wide">Lote GNRE</TableHead>
                                <TableHead className="font-semibold text-xs uppercase tracking-wide">Data</TableHead>
                                <TableHead className="font-semibold text-xs uppercase tracking-wide">Gerado por</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {nffHistory.map((item) => (
                                <TableRow key={item.id} className="hover:bg-muted/50">
                                    <TableCell>
                                        <code className="px-2 py-1 bg-green-50 text-green-700 rounded text-xs font-mono">
                                            {item.nff || "-"}
                                        </code>
                                    </TableCell>
                                    <TableCell>
                                        <code className="px-2 py-1 bg-muted rounded text-xs font-mono">{item.batch}</code>
                                    </TableCell>
                                    <TableCell className="text-sm">
                                        {format(new Date(item.created_at), "dd/MM/yyyy HH:mm", { locale: ptBR })}
                                    </TableCell>
                                    <TableCell className="text-sm">{item.generated_by || "Sistema"}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        </div>
    )
}
